import React from "react";
import '../assets/css/PlayerList.css';
import { useState } from "react";

import boyImage from '../assets/images/boy.png';
import girlImage from '../assets/images/girl.png';

const PlayerListContainer = ({ player, button, CustomButton, deleteIcon }) => {
    const [selectedPlayers, setSelectedPlayers] = useState({});
    const handleButtonClick = (playerId) => {
        setSelectedPlayers((prev) => ({
            ...prev,
            [playerId]: !prev[playerId],
        }));
    };
 
    return (
        <div className="col-lg-12 col-sm-12 col-md-12 player-list-container player-container pb-4" style={{ boxShadow: "gray 0px 0px 2px" }} >
            <div className=" d-flex justify-content-between align-items-end" >
                <div className="d-flex row w-100">
                    <div className="d-flex align-items-center col-4 col-sm-4 col-lg-4">
                        <div>
                            <img src={player.avatarUrl || player.image || boyImage} alt={`${player.name}`} className="player-image" style={{ width: '60px' }} />
                            <div
                                title={player?.name}
                                style={{
                                    color: '#1F2024',
                                    fontWeight: 400,
                                    fontSize: '11px',
                                    textAlign: 'center',
                                    cursor: 'default'
                                }}
                            >
                                {player?.name?.length > 6 ? `${player.name.slice(0, 6)}...` : player?.name}
                            </div>

                        </div>
                        <div style={{ height: '70px', marginLeft: '10px', width: '7px', backgroundColor: '#e9ecef', borderRadius: '0px', overflow: 'hidden' }}>
                            <div
                                style={{
                                    height: `${player?.reliability || player?.reliabilty || player?.reliabilityNum}%`,
                                    width: '100%',
                                    backgroundColor: 'green',
                                    transition: 'height 0.3s ease',
                                }}
                            ></div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-4 col-lg-6 d-flex justify-content-between align-items-center">
                        <div>
                            <span style={{ color: "#1F2024", fontWeight: 700, lineHeight: "18.94px", fontSize: '13px', }}>
                                {player?.avatarName}
                            </span>
                            {" "}
                            {player.age}
                            {" "}
                            <span className="" style={{ fontSize: '12px', color: '#71727A' }}>
                                {player.gender && `(${player.gender})`}
                            </span>
                            <br />
                            <span className="me-1">{player?.sport}</span>
                            <span className="player-skill">
                                {player?.skill || player?.skillLevel ? `(${player?.skill || player?.skillLevel})` : ''}
                            </span>
                            {player?.sportProfiles &&
                                <span >
                                    {player?.sportProfiles[0]?.sport}
                                    <span className="ms-1" style={{ fontSize: '12px', color: '#71727A' }}>{player?.sportProfiles && `(${player?.sportProfiles[0]?.skillLevel})`}</span>
                                </span>
                            }

                        </div>
                    </div>
                    <div className=" col-2 delete-icon-container col-lg-2">
                        {deleteIcon}
                    </div>

                </div>
            </div>
            <div className=" pt-2 w-100 d-flex justify-content-between align-items-center">
                <div className="w-100" style={{ fontWeight: 400, fontSize: "14px", lineHeight: "14px", color: "#71727A", }}    >
                    <div className="d-flex justify-content-between align-items-center pt-2 w-100">
                        <div>
                            <div className="distance-text pt-2">
                                {player.distance ? (Number(player.distance) * 0.000621371).toFixed(2) : '0.00'}
                                {" "} miles away
                            </div>

                        </div>
                        <div>
                            {CustomButton && (
                                <CustomButton
                                    id={`player-btn-${player.id}`}
                                    buttonText={selectedPlayers[player.id] ? "Selected" : "Invite"}
                                    onClick={() => handleButtonClick(player.id)}
                                    style={{
                                        color: "#fff",
                                        padding: "8px 12px",
                                        cursor: "pointer",
                                        borderRadius: "5px",
                                        border: "none",
                                    }}
                                    className="custom-player-button"
                                />
                            )}
                        </div>
                    </div>
                </div>
                <div>{button}</div>
            </div>


        </div>
    );
};
export default PlayerListContainer;